export default "__VITE_ASSET__BQ_PGnjG__"